const customFont = '"Roboto", sans-serif';

interface GetPaymentWidgetStylesArgs {
  screenWidth: number;
}

export const getPaymentWidgetStyles = ({
  screenWidth,
}: GetPaymentWidgetStylesArgs) => {
  const isMobile = screenWidth <= 576;

  if (isMobile) {
    return `
      ${baseCustomStyles}
      ${mobileCustomStyles}
    `
  }

  return baseCustomStyles;
};

const mobileCustomStyles = `
    /* Payment Options Wrapper */
    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type {
      grid-template-columns: 1fr;
    }

    /* Payment Fields */
    body > app-root > main #paymentForm > div,
    body > app-root > main #bankTransferSection > div > div:first-of-type {
      grid-template-columns: 1fr;
    }

    /* Payment field wrapper */
    body > app-root > main #paymentForm > div > div:nth-child(odd),
    body > app-root > main #bankTransferSection > div > div > div:nth-child(odd)
    {
      padding-left: 12px;
      padding-right: 12px;
    }

    body > app-root > main #paymentForm > div > div:nth-child(even),
    body > app-root > main #bankTransferSection > div > div > div:nth-child(even)
    {
      padding-right: 12px;
      padding-left: 12px;
    }

    /* Payment field input */
    body > app-root > main #paymentForm > div > div input,
    body > app-root > main #paymentForm > div > div > div.input-container > div,
    body > app-root > main #bankTransferSection > div > div > div > div > input
    {
      font-size: 14px !important;
    }
`;

const baseCustomStyles = `
    body > app-root > main {
      font-family: ${customFont} !important;
      font-size: 16px !important;
    }

    /* Payment Options Wrapper */
    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type {
      margin-top: 0 !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      width: 100%;
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      gap: 18px;
      margin-bottom: 24px;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div {
      width: 100% !important;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div:first-child {
      padding-right: 0 !important;
      padding-left: 0 !important;
      margin-bottom: 0 !important;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div:last-child {
      padding-left: 0 !important;
      margin-right: 0 !important;
      padding-right: 0 !important;
      margin-bottom: 0 !important;
    }

    /* Payment Button */
    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option {
      border: 1px solid #E0E0E0 !important;
      padding: 16px !important;
      font-family: ${customFont} !important;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option > div {
      display: flex;
      align-items: center;
      column-gap: 8px;
      margin-bottom: 0;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option > div > input[type="radio"] {
      margin-top: 0;
      border-color: #777777 !important;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option > div > label.form-check-label > i {
      display: none;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option > div > input[type="radio"]:checked {
      border-color: #fff !important;
      background-color: #080A2D;
    }

    body > app-root > main > div > div > app-payment-flow > app-payment > div:first-of-type > div > div.payment-option:has(input[type="radio"]:checked) {
      background-color: #080A2D !important;

      & > div > label.form-check-label {
        color: #fff !important;
      }
    }

    /* Payment fields */
    body > app-root > main #paymentForm > div,
    body > app-root > main #bankTransferSection > div > div:first-of-type {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 24px;
      padding-bottom: 20px; /* Add padding to the bottom of the Payment fields otherwise the fields would not be visible */
    }

    /* Payment field wrapper */
    body > app-root > main #paymentForm > div > div,
    body > app-root > main #bankTransferSection > div > div > div
    {
      width: 100%;
      margin-bottom: 0 !important;
      padding-right: 0;
      padding-left: 0;
    }

    body > app-root > main #paymentForm > div > div:nth-child(odd),
    body > app-root > main #bankTransferSection > div > div > div:nth-child(odd)
    {
      padding-left: 12px;
    }

    body > app-root > main #paymentForm > div > div:nth-child(even),
    body > app-root > main #bankTransferSection > div > div > div:nth-child(even)
    {
      padding-right: 12px;
    }

    /* Payment field label */
    body > app-root > main #paymentForm > div > div > label,
    body > app-root > main #bankTransferSection > div > div > div > label
    {
      font-family: ${customFont} !important;
      font-size: 16px !important;
      font-weight: 400;
      color: #777777 !important;
      margin-bottom: 0px;
    }

    /* Credit Card field input Cards Row */
    body > app-root > main #paymentForm > div > div > div.credit-cards {
      display: none !important;
    }

    /* Payment field input */
    body > app-root > main #paymentForm > div > div input,
    body > app-root > main #paymentForm > div > div > div.input-container > div,
    body > app-root > main #bankTransferSection > div > div > div > div > input
    {
      border-width: 1px;
      border-color: #EAF6EC !important;
      border-radius: 4px !important;
      font-size: 16px !important;
      box-shadow: none !important;
      height: 56px !important;
    }

    /* Plaid IFrame */
    html#plaid-link-temporary-id > body > .plaid-link-iframe {
      padding-top: 200px !important;
    }
`;
